<template>
    <div>
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_swap')}}</h3>
            <p>{{$t('cal_swap_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
            <div class="tabInner">
                <nav class="mb-5">
                    <div id="nav-tab" role="tablist" class="d-flex align-items-center justify-content-center nav nav-tabs border-0">
                        <a id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" class="nav-item nav-link" :class="(showTab == 'Mt4-5')?'active' : ''" @click.prevent="showTab = 'Mt4-5';resetTab();">{{$t('cal_swap_MT4_MT5')}}</a>
                        <a id="nav-profile-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-profile" aria-selected="false" class="nav-item nav-link " :class="(showTab == 'ACT')?'active' : ''" @click.prevent="showTab = 'ACT'; resetTab()">{{$t('cal_swap_ACT')}}</a> 
                    </div>
                </nav>
                <!-- <nav class="mb-5">
                    <div id="nav-tab" role="tablist" class="nav nav-tabs nav-fill w-50 m-0 border-0">
                        <a id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" class="nav-item nav-link border-0" :class="(showTab == 'Mt4-5')?'active' : ''" @click.prevent="showTab = 'Mt4-5';resetTab();">MT4/MT5</a>
                        <a id="nav-profile-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-profile" aria-selected="false" class="nav-item nav-link border-0" :class="(showTab == 'ACT')?'active' : ''" @click.prevent="showTab = 'ACT'; resetTab()">ACT</a> 
                    </div>
                </nav> -->
                <div id="nav-tabContent" class="tab-content w-100 px-0">
                    <div id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" class="tab-pane fade show active">
                        <p v-if="message != ''" style="color:red">{{message}}</p>
                        <div class="bottomTab">
                            <div class="stepForm-contact">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group field-wrapper">
                                            <select class="selectpicker float-field form-control" @change="getSymbol(segm)" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                                <!-- <option value=""></option> -->
                                                <option value="forex">{{$t('cal_marg_forex')}}</option>
                                                <option value="commd">{{$t('cal_marg_commodities')}}</option>
                                                <option value="indic">{{$t('cal_marg_indices')}}</option>
                                                <!--<option>Crypto</option>-->
                                            </select>
                                            <label class="float-label">Asset Class</label>
                                            <p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_swap_Field_req')}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group field-wrapper">
                                            <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                                <!-- <option value=""></option> -->
                                                <option value="USD">{{$t('cal_comm_USD')}}</option>
                                                <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                                <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                                <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                            </select>
                                            <label class="float-label">{{$t('cal_swap_accBaseCurr')}}</label>
                                            <p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_swap_Field_req')}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group field-wrapper">
                                            <select class="selectpicker float-field form-control" v-model="selectedSymbol" v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                               <!--  <option value=""></option> -->
                                                <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                            </select>
                                            <label class="float-label">{{$t('cal_swap_Symbol')}}</label>
                                            <p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_swap_Field_req')}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input placeholder=" " type="text" class="float-field form-control" v-model="noofdays" v-validate="{ required: true,numeric:true}" name="noofdays" :class="{ 'is-invalid': submitted && errors.has('noofdays') }">
                                            <label class="float-label"> {{$t('cal_swap_Num_Days')}}</label>
                                            <p class="error" v-if="submitted" v-for="error in errors.collect('noofdays')">{{$t('cal_swap_Field_req')}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input type="text" v-model="tradesize" class="float-field form-control" v-validate="{ required: true,decimal:5}" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                            <label class="float-label" style="text-transform: none !important;">{{$t('cal_swap_trade_size_lot')}}</label>
                                            <p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_swap_Field_req')}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="form-group field-wrapper">
                                            <a href="#" class="common_btn" v-on:click.prevent="calculateComm()" v-if="showTab == 'Mt4-5'">Calculate Now</a>
											<a href="#" class="common_btn" v-on:click.prevent="calculateCommAct()" v-else>Calculate Now</a>
                                            <p class="mt-3"><strong>{{$t('cal_swap_Swap_Long')}}</strong>: {{longswap}} <span class="ml-2"><strong>{{$t('cal_swap_Swap_Short')}}</strong>: {{shortswap}}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'PIP',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": '',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
                "longswap":0,
                "shortswap":0,
                "noofdays": "0",
				submitted : false,
				message : '',
				showTab : 'Mt4-5'
            }
        },
        methods:{
            resetTab(){
                this.isins='';
                this.segm= '';
                this.tradesize=0;
                this.selectedSymbol="";
                this.selectedSeg="";
                this.commission= 0;
                this.basecurreny='USD';
                this.longswap=0;
                this.shortswap=0;
                this.noofdays= "0";
                this.submitted= false;
                this.message = '';
            },
            getSymbol(getSymbolFor){
                if(getSymbolFor == 'commd'){
                    this.isins = Object.keys(this.get_Commodity_All)
                }if(getSymbolFor == 'forex'){
                    this.isins = Object.keys(this.get_currencies)
                }if(getSymbolFor == 'indic'){
                    this.isins = Object.keys(this.get_Indices_all)
                }

                this.selectedSeg = getSymbolFor

                // this.isins = getData
            },
			calculateCommAct(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						let symb = ""
						symb = _that.all_currencies_price[_that.selectedSymbol]
						if(parseFloat(_that.tradesize) >= parseFloat(symb.other.Min_Trade_Size)){
							let contractSize = symb.other.Contract_Size
							contractSize = contractSize.match(/(\d+)/)[0]; 
							let currencyPrice = _that.currencyConverstion(_that.selectedSymbol)

							_that.longswap = parseFloat(_that.noofdays * _that.tradesize * symb.other.Long_Swaps).toFixed(2)
							_that.shortswap = parseFloat(_that.noofdays * _that.tradesize * symb.other.Short_Swaps).toFixed(2)
							
						}else{
							_that.message = "Minimum trade size should be "+ parseFloat(symb.other.Min_Trade_Size)
						}
					}
				})
			},
            calculateComm(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						//selected symbol
						let symb = ""

						symb = _that.all_currencies_price[_that.selectedSymbol]
						//Data will come here with all live price
						if(parseFloat(_that.tradesize) >= parseFloat(symb.other.Min_Trade_Size)){
							let contractSize = symb.other.Contract_Size

							contractSize = contractSize.match(/(\d+)/)[0]; 

							//: ( Lot * contract size* (first currency to base currency) *2) /100,000
							let currencyPrice = _that.currencyConverstion(_that.selectedSymbol)

							// Pip size X Contract size X (Second currency conversion to Base currency ) 

							// No. of Lots X Swap Points X Contract Size X Minimum Price Fluctuations X Days * Conversion price to account base currency

							if(_that.selectedSeg == 'indic'){
								_that.longswap = parseFloat(_that.noofdays * _that.tradesize * symb.other.Long_Swaps).toFixed(2)
								_that.shortswap = parseFloat(_that.noofdays * _that.tradesize * symb.other.Short_Swaps).toFixed(2)
							}else{
								_that.longswap = parseFloat(_that.tradesize * symb.other.Long_Swaps * contractSize * symb.other.Tick_Size *currencyPrice * _that.noofdays).toFixed(2)
								_that.shortswap = parseFloat(_that.tradesize * symb.other.Short_Swaps * contractSize * symb.other.Tick_Size * currencyPrice * _that.noofdays).toFixed(2)
							}
						}else{
							_that.message = "Minimum trade size should be "+ parseFloat(symb.other.Min_Trade_Size)
						}
					}
				})
            },
            currencyConverstion(selectedSymbol){
                //all_currencies_price will get all currecies prices

                let secondCurrency = selectedSymbol.substring(3, 6);

                if(secondCurrency == this.basecurreny){
                    return 1
                }

                else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
                    return this.all_currencies_price[secondCurrency+this.basecurreny].A
                } 

                else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
                    return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
                } 
                else{

                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(this.all_currencies_price[secondCurrency+"USD"]){
                        secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+secondCurrency]){
                        secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
                    } 

                    if(this.all_currencies_price[this.basecurreny+"USD"]){
                        accBasetoUSD = this.all_currencies_price[this.basecurreny+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+this.basecurreny]){
                        accBasetoUSD = 1/this.all_currencies_price["USD"+this.basecurreny].A
                    } 

                    return accBasetoUSD/secontoUSD
                }
                return 1
            }
        },
        created(){
            this.getSymbol('forex')
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/swap.vue